import moment from 'moment'
import React from 'react'

import { ConflictPrompt } from 'components/authentication/registration/self-service/ConflictPrompt'
import BusyOverlay from 'components/common/BusyOverlay'

export const AccountNameConflictForm: React.FC<{
  companyName: string | string[]
  disabled: boolean
  handleClearConflict: () => void
  handleCompanyNameChange: (name: string) => void
}> = ({
  companyName,
  disabled,
  handleClearConflict,
  handleCompanyNameChange
}) => {
  const date = moment(new Date()).format('DDMMYY')
  const alternateNames = [`${companyName} ${date}`, `${companyName}_${date}`]

  return (
    <div data-test-account-name-conflict-form>
      {disabled ? (
        <BusyOverlay shown={true} />
      ) : (
        <ConflictPrompt
          alternateNames={alternateNames}
          companyName={companyName}
          handleClearConflict={handleClearConflict}
          handleCompanyNameChange={handleCompanyNameChange}
        />
      )}
    </div>
  )
}
